import ProfilePosts from "./ProfilePosts";
export default ProfilePosts;
